import lazyload from 'app/libs/lazyload';

// common
export const RedirectPage = lazyload(() => import('../common/RedirectPage'));

export const DetailPage = lazyload(() => import('./DetailPage'));
export const CarPhotoViewPage = lazyload(() => import('./CarPhotoViewPage'));
export const NewcarPage = lazyload(() => import('./NewcarPage'));
export const LeaseRentPage = lazyload(() => import('./LeaseRentPage'));
export const RepaymentSchedulePage = lazyload(() => import('./RepaymentSchedulePage'));
export const ReportDignosisPage = lazyload(() => import('./ReportDignosisPage'));
export const ReportInspectPage = lazyload(() => import('./ReportInspectPage'));
export const ReportInspectImagePage = lazyload(() => import('./ReportInspectImagePage'));
export const ReportAccidentPage = lazyload(() => import('./ReportAccidentPage'));
export const ReportEncarPassPage = lazyload(() => import('./ReportEncarPassPage'));
export const ReportEvInfoPage = lazyload(() => import('./ReportEvInfoPage'));
export const PeerIntoCarOptionDetailPage = lazyload(() => import('./PeerIntoCarOptionDetailPage'));
export const PeerIntoCarOptionsPage = lazyload(() => import('./PeerIntoCarOptionsPage'));
export const PeerIntoCarOptionInfoPage = lazyload(() => import('./PeerIntoCarOptionInfoPage'));
export const HomeServiceQuestionPage = lazyload(() => import('./HomeServiceQuestionPage'));
export const FakeCarComplaintPage = lazyload(() => import('./FakeCarComplaintPage'));

export const AcquisitionCostPage = lazyload(() => import('./AcquisitionCostPage'));
export const AcquisitionCostPcPage = lazyload(() => import('./AcquisitionCostPcPage'));
export const AcquisitionHomeservicePage = lazyload(() => import('./AcquisitionHomeservicePage'));

// 진단 보상 규정
export const DiagnosisCompensatePage = lazyload(() => import('./DiagnosisCompensatePage'));
export const DiagnosisStandardPage = lazyload(() => import('./diagnosisCompensate/DiagnosisStandardPage'));
export const DiagnosisRangePage = lazyload(() => import('./diagnosisCompensate/DiagnosisRangePage'));
export const CompensateAccidentPage = lazyload(() => import('./diagnosisCompensate/CompensateAccidentPage'));
export const CompensateOptionPage = lazyload(() => import('./diagnosisCompensate/CompensateOptionPage'));
export const CompensateGradePage = lazyload(() => import('./diagnosisCompensate/CompensateGradePage'));
